export default "__VITE_ASSET__BB1yrBQp__"